import {ReactNode, ButtonHTMLAttributes} from 'react';

enum HOVER_TYPE_ENUM {
	CIRCLE = 'circle',
	COLOR = 'color',
}

interface DayProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	day?: string | number;
	isDaySelected?: boolean;
	isToday?: boolean;
	isDisableColor?: boolean;
	weekendDay?: number;
	inative?: boolean;
	hoverType?: HOVER_TYPE_ENUM;
	setBackgroundInterval?: boolean;
	isFirstDaySelected?: boolean;
	isSecondDaySelected?: boolean;
	isLastDayOfMonth?: boolean;
	tooltipData?: string;
	iconPinDay?: ReactNode;
	selectIconPinDay?: ReactNode;
	colorPinDay?: string;
	showBackgroundIntervalWhenHover?: boolean;
	hasFirstDaySelected?: boolean;
	hasSecondDaySelected?: boolean;
	onClickDay?: () => void;
	onMouseEnter?: () => void;
}

interface DayStyleProps {
	hoverType?: HOVER_TYPE_ENUM;
	setBackgroundInterval?: boolean;
	isDaySelected?: boolean;
	isSunday?: boolean;
	isSaturday?: boolean;
	isFirstDaySelected?: boolean;
	isSecondDaySelected?: boolean;
	isFirstDayOfMonth?: boolean;
	isLastDayOfMonth?: boolean;
	isDisableColor?: boolean;
	hasTooltip?: boolean;
	hasColorPinDay?: boolean;
	hasFirstDaySelected?: boolean;
	hasSecondDaySelected?: boolean;
	showBackgroundIntervalWhenHover?: boolean;
}

export {HOVER_TYPE_ENUM};
export type {DayProps, DayStyleProps};
